// dashboard/frontend/src/components/Campaign/channels/email/EmailDraftRow.js

import React from 'react';
import BaseDraftRow from '../BaseDraftRow';
import EmailDraftActions from './EmailDraftActions';
import ChannelFactory from '../ChannelFactory';

/**
 * Email-specific draft row wrapper
 * This component combines BaseDraftRow with EmailDraftActions
 */
const EmailDraftRow = ({ 
    contact, 
    draft,
    onViewInGmail,
    onRefreshDraft,
    onDeleteDraft,
}) => {
    // Get email channel configuration
    const channelConfig = ChannelFactory.getChannelConfig('email');

    // Render function for email-specific actions
    const renderActions = (props) => (
        <EmailDraftActions
            {...props}
            onViewInGmail={onViewInGmail}
            onRefreshDraft={onRefreshDraft}
            onDeleteDraft={onDeleteDraft}
        />
    );

    return (
        <BaseDraftRow
            contact={contact}
            draft={draft}
            channelConfig={channelConfig}
            actions={renderActions}
        />
    );
};

export default EmailDraftRow;